import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    AOS.init({ duration: 400, once: true });
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex justify-center items-center px-4">
      <div
        ref={modalRef}
        className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl max-w-2xl w-full relative animate-fade-in"
        data-aos="zoom-in"
      >
        <button
          onClick={onClose}
          aria-label="Close Modal"
          className="absolute top-3 right-4 text-2xl font-bold text-gray-500 hover:text-red-600 focus:outline-none"
        >
          &times;
        </button>
        <div className="mt-2">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
